import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './gallery1.css'

const Gallery1 = (props) => {
  return (
    <div className="gallery1-gallery3 thq-section-padding">
      <div className="gallery1-max-width thq-section-max-width">
        <div className="gallery1-section-title">
          <h2>
            {props.heading1 ?? (
              <Fragment>
                <h2 className="gallery1-text12 thq-heading-2">
                  AI for The Commonwealth Nations
                </h2>
              </Fragment>
            )}
          </h2>
          <span>
            {props.content1 ?? (
              <Fragment>
                <span className="gallery1-text13 thq-body-large">
                  <span>
                    The CAIC’s broad objective is to provide leadership, 
                  </span>
                  <span>
                    governance, advocacy and advisory services on the 
                  </span>
                  <span>
                    entire AI ecosystem for the Commonwealth Small States 
                  </span>
                  <span>
                    to adopt transformative and AI-driven technologies for 
                  </span>
                  <span>
                    the safe, inclusive and sustainable advancement of the 
                  </span>
                  <span>members.</span>
                </span>
              </Fragment>
            )}
          </span>
        </div>
        <div className="gallery1-content">
        <video
            className="gallery1-video"
            width="100%"
            height="auto"
            controls
          >
            <source src={props.videoSrc} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </div>
  )
}
Gallery1.defaultProps = {
  heading1: undefined,
  content1: undefined,
  videoSrc: '/video6.mp4',
}

Gallery1.propTypes = {
  heading1: PropTypes.element,
  content1: PropTypes.element,
  videoSrc: PropTypes.string,
}

export default Gallery1